import React from "react";

// Material UI
import {
  Alert,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

// Styles
import { buttonStyles, textStyles } from "Common/Styles";

const SuccessDialog = ({
  onOpen,
  onClose,
  accountName,
  isUpdating,
  isClient = false,
}) => {
  return (
    <Dialog open={onOpen} onClose={onClose}>
      <DialogTitle sx={textStyles.title}>Success!</DialogTitle>
      <DialogContent>
        <DialogContentText>
          {isClient ? "Client" : "Clinic"} <strong>{accountName}</strong> was
          successfully {isUpdating ? "updated" : "created"}.
        </DialogContentText>
        {isUpdating && isClient && (
          <Alert severity="warning" variant="outlined">
            Please note that all clinics associated with this client may need to
            be updated manually.
          </Alert>
        )}
        {!isUpdating && !isClient && (
          <Alert severity="info" variant="outlined">
            To activate it, please head to the <strong>Inactive</strong> tab.
          </Alert>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          variant="contained"
          onClick={onClose}
          sx={{ ...buttonStyles.greenActionButton, px: 4 }}
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SuccessDialog;
